import React from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';

type Props = {
    children: React.ReactNode;
};

export const FeatureFlagsProvider: React.FC<Props> = ({ children }) => {
    const ldOptions = {
        // bootstrap: 'localStorage',
        application: {
            id: 'quality-by-foundations',
        },
    } as const;

    return (
        <LDProvider
            clientSideID={process.env.LAUNCH_DARKLY_CLIENT_ID}
            options={ldOptions}
        >
            {children}
        </LDProvider>
    );
};

export default FeatureFlagsProvider;
